// extracted by mini-css-extract-plugin
export default {"content":"HeroContent_content__VFdtI","title":"HeroContent_title__A8UMN","description":"HeroContent_description__1kqfA","control":"HeroContent_control__wnCo+"};